module.exports = __webpack_public_path__ + "static/img/dr-laila.0d2a239c.jpg";